import { FC, useState } from "react";
import { SettingsToolIcon, OpacityPopup, ColorPickerPopup } from "shared/ui";
import type { AcceleratorOscillatorSettings } from "../../model";
import styles from "./AcceleratorOscillatorStylesTab.module.css";

type OpenPopup = "opacity" | "up-color" | "down-color" | null;

interface Props {
  settings: AcceleratorOscillatorSettings;
  onChange: (s: AcceleratorOscillatorSettings) => void;
}

export const AcceleratorOscillatorStylesTab: FC<Props> = ({ settings, onChange }) => {
  const [openPopup, setOpenPopup] = useState<OpenPopup>(null);

  const toggle = (popup: OpenPopup) =>
    setOpenPopup((prev) => (prev === popup ? null : popup));

  return (
    <div className={styles.tab}>
      <div className={styles.row}>
        <div className={styles.left}>
          <label className={styles.checkboxWrap}>
            <input
              type="checkbox"
              className={styles.checkboxInput}
              checked={settings.mainLineVisible}
              onChange={(e) => onChange({ ...settings, mainLineVisible: e.target.checked })}
            />
            <span className={styles.checkmark} />
          </label>
          <span className={styles.label}>Main Line</span>
        </div>
        <div className={styles.btnWrap}>
          <button
            className={styles.iconBtn}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={() => toggle("opacity")}
          >
            <SettingsToolIcon width={16} height={16} />
          </button>
          {openPopup === "opacity" && (
            <OpacityPopup
              opacity={settings.mainLineOpacity}
              onChange={(v) => onChange({ ...settings, mainLineOpacity: v })}
              onClose={() => setOpenPopup(null)}
            />
          )}
        </div>
      </div>

      <div className={styles.row}>
        <span className={`${styles.label} ${styles.labelIndented}`}>up</span>
        <div className={styles.btnWrap}>
          <button
            className={styles.colorBtn}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={() => toggle("up-color")}
          >
            <span className={styles.colorBtnSwatch} style={{ background: settings.upColor }} />
          </button>
          {openPopup === "up-color" && (
            <ColorPickerPopup
              color={settings.upColor}
              onChange={(c) => onChange({ ...settings, upColor: c })}
              onClose={() => setOpenPopup(null)}
            />
          )}
        </div>
      </div>

      <div className={styles.row}>
        <span className={`${styles.label} ${styles.labelIndented}`}>down</span>
        <div className={styles.btnWrap}>
          <button
            className={styles.colorBtn}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={() => toggle("down-color")}
          >
            <span className={styles.colorBtnSwatch} style={{ background: settings.downColor }} />
          </button>
          {openPopup === "down-color" && (
            <ColorPickerPopup
              color={settings.downColor}
              onChange={(c) => onChange({ ...settings, downColor: c })}
              onClose={() => setOpenPopup(null)}
            />
          )}
        </div>
      </div>
    </div>
  );
};
